import { Route } from 'react-router-dom'
import TodosView from 'screens/Todos'
import NewDashboard from 'screens/Todos/NewDashboard/NewDashboard'
import NewManager from 'screens/Todos/NewManager'

const INDEX = 'todos'
const DASHBOARD = 'dashboard'
const MANAGE = 'manage'

export const TODOS = {
  INDEX: `/${INDEX}`,
  DASHBOARD: `/${INDEX}/${DASHBOARD}`
}

export const todosRoutes = (
  <Route path={INDEX} element={<TodosView />}>
    <Route path={DASHBOARD} element={<NewDashboard />} />
    <Route path={MANAGE} element={<NewManager />} />
  </Route>
)

export default todosRoutes
